import React from 'react';
import PropTypes from 'prop-types';

const NewItemButton = props => (
  <div className="newItemButton">
    <button
      className="btn btn-tertiary outline"
      type="submit"
      onClick={() => {
        props.addItem(props.containerId);
      }}
    >
      Add New Window
    </button>
  </div>
);

NewItemButton.propTypes = {
  containerId: PropTypes.string.isRequired,
  addItem: PropTypes.func.isRequired,
};

export default NewItemButton;
